import type { UserAddress } from '../types';
import { formatAddressLine, formatAddressRecipient } from '../utils/address';

type AddressCardProps = {
  address: UserAddress;
  busy?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  onSetDefaultShipping: () => void;
  onSetDefaultBilling: () => void;
};

export default function AddressCard({
  address,
  busy = false,
  onEdit,
  onDelete,
  onSetDefaultShipping,
  onSetDefaultBilling,
}: AddressCardProps) {
  return (
    <article className="address-card">
      <div className="address-card-head">
        <div>
          <strong>{address.label}</strong>
          <span>{formatAddressRecipient(address)}</span>
        </div>
        <div className="address-badges">
          {address.isDefaultShipping && (
            <span className="address-badge address-badge-shipping">Varsayılan teslimat</span>
          )}
          {address.isDefaultBilling && (
            <span className="address-badge address-badge-billing">Varsayılan fatura</span>
          )}
        </div>
      </div>

      <p className="address-card-line">{formatAddressLine(address)}</p>
      <p className="address-card-meta">{address.country}</p>

      <div className="address-actions">
        <button type="button" className="btn btn-outline btn-sm" disabled={busy} onClick={onEdit}>
          Düzenle
        </button>
        {!address.isDefaultShipping && (
          <button
            type="button"
            className="btn btn-outline btn-sm"
            disabled={busy}
            onClick={onSetDefaultShipping}
          >
            Teslimat yap
          </button>
        )}
        {!address.isDefaultBilling && (
          <button
            type="button"
            className="btn btn-outline btn-sm"
            disabled={busy}
            onClick={onSetDefaultBilling}
          >
            Fatura yap
          </button>
        )}
        <button
          type="button"
          className="btn btn-outline btn-sm address-delete-btn"
          disabled={busy}
          onClick={onDelete}
        >
          Sil
        </button>
      </div>
    </article>
  );
}
